module.exports = __webpack_public_path__ + "img/login@2x.e96a01d0.png";